<div class="dashboard-container">

  <!-- Card del Gráfico de Tareas por Estado -->
  <mat-card appearance="outlined" class="chart-card"  >
 <ngx-spinner [zIndex]="100" name="spAccesoRapido" bdColor="rgba(255,255,255,0.8)" size="default"
    color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
  </ngx-spinner>
    <mat-card-header class="card-header">
      <div class="header-content">
        <mat-icon class="header-icon">pie_chart</mat-icon>
        <div class="header-text">
          <mat-card-title>Mis Accesos Rápidos</mat-card-title>
          <mat-card-subtitle>Listado de sitios frecuentes.</mat-card-subtitle>
        </div>
        <!-- <span>Mis Accesos Rápidos</span> -->
        <!-- <span class="spacer"></span> -->

        <!-- Filtros rápidos -->
        <button mat-icon-button [color]="mostrarSoloFavoritos ? 'accent' : ''" (click)="toggleMostrarSoloFavoritos()"
          matTooltip="Mostrar solo favoritos">
          <mat-icon>{{ mostrarSoloFavoritos ? 'star' : 'star_border' }}</mat-icon>
        </button>

        <button mat-icon-button [matMenuTriggerFor]="menuAcciones" matTooltip="Más acciones">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menuAcciones="matMenu">
          <button mat-menu-item (click)="verificarUrlsMasivas()">
            <mat-icon>link</mat-icon>
            <span>Verificar todas las URLs</span>
          </button>
          <button mat-menu-item (click)="reorganizarAutomaticamente()">
            <mat-icon>auto_fix_high</mat-icon>
            <span>Reorganizar por uso</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="limpiarFiltros()">
            <mat-icon>clear_all</mat-icon>
            <span>Limpiar filtros</span>
          </button>
        </mat-menu>

        <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar, modulo: 'AccesosRapidos' })"
          *appRoles="['AccesosRapidos.Crear']">
        </app-button-new>
      </div>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content class="chart-content" >

      <div class="contenedor mx-auto">



        <!-- Barra de filtros -->
        <div class="filtros-container" *ngIf="accesos.length > 5">
          <form [formGroup]="filtrosForm" class="filtros-form">

            <mat-form-field appearance="outline" class="filtro-busqueda">
              <mat-label>Buscar accesos...</mat-label>
              <input matInput formControlName="filtroTexto" placeholder="Título, URL o descripción">
              <mat-icon matSuffix>search</mat-icon>
              <mat-hint *ngIf="filtroTexto">
                {{ accesosFiltrados.length }} resultado(s) encontrado(s)
              </mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filtro-grupo" *ngIf="gruposDisponibles.length > 0">
              <mat-label>Filtrar por grupo</mat-label>
              <mat-select formControlName="grupoSeleccionado">
                <mat-option value="">Todos los grupos</mat-option>
                <mat-option *ngFor="let grupo of gruposDisponibles" [value]="grupo">
                  {{ grupo }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>category</mat-icon>
            </mat-form-field>

          </form>
        </div>

        <!-- Indicador de filtros activos -->
        <!-- <div class="filtros-activos" *ngIf="filtroTexto || grupoSeleccionado || mostrarSoloFavoritos">
    <mat-chip-listbox class="filtros-chips">
      <mat-chip-option *ngIf="filtroTexto"
                       removable
                       (removed)="filtrosForm.patchValue({ filtroTexto: '' })">
        <mat-icon class="chip-icon">search</mat-icon>
        "{{ filtroTexto }}"
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-option>

      <mat-chip-option *ngIf="grupoSeleccionado"
                       removable
                       (removed)="filtrosForm.patchValue({ grupoSeleccionado: '' })">
        <mat-icon class="chip-icon">category</mat-icon>
        {{ grupoSeleccionado }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-option>

      <mat-chip-option *ngIf="mostrarSoloFavoritos"
                       removable
                       (removed)="filtrosForm.patchValue({ mostrarSoloFavoritos: false })">
        <mat-icon class="chip-icon">star</mat-icon>
        Solo favoritos
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-option>
    </mat-chip-listbox>

    <button mat-button
            color="primary"
            (click)="limpiarFiltros()"
            class="limpiar-todo">
      <mat-icon>clear_all</mat-icon>
      Limpiar todo
    </button>
  </div> -->

        <!-- Lista de accesos - Layout compacto en una línea -->
        <div class="contenedor-accesos" *ngIf="accesosFiltrados.length > 0; else sinAccesos">
          <div cdkDropList (cdkDropListDropped)="ordenar($event)" class="accesos-lista">
            <div *ngFor="let acceso of accesosFiltrados; trackBy: trackByAcceso" cdkDrag class="acceso-item-compact"
              [class.acceso-favorito]="acceso.esFavorito" [class.acceso-inactivo]="!acceso.activo">

              <!-- Layout horizontal compacto -->
              <div class="acceso-content-horizontal">

                <!-- Icono del acceso -->
                <div class="acceso-icono-small">
                  <mat-icon [style.color]="acceso.color || '#1976d2'">
                    {{ acceso.icono || 'bookmark' }}
                  </mat-icon>
                </div>

                <!-- Título (principal) -->
                <div class="acceso-titulo-principal">
                  <a [href]="acceso.url" target="_blank" (click)="registrarVisita(acceso)" class="titulo-link"
                    [matTooltip]="acceso.url">
                    {{ acceso.titulo }}
                  </a>
                </div>

                <!-- Categoría en chip pequeño -->
                <div class="categoria-chip" *ngIf="acceso.grupo">
                  <span class="chip-categoria-small" [style.background-color]="(acceso.color || '#1976d2') + '15'"
                    [style.color]="acceso.color || '#1976d2'" [style.border-color]="(acceso.color || '#1976d2') + '30'">
                    {{ acceso.grupo }}
                  </span>
                </div>

                <!-- Cantidad de visitas -->
                <div class="visitas-counter">
                  <mat-icon class="visitas-icon">visibility</mat-icon>
                  <span class="visitas-numero">{{ acceso.cantidadVisitas || 0 }}</span>
                </div>

                <!-- Spacer para empujar acciones a la derecha -->
                <div class="spacer-flex"></div>

                <!-- Acciones alineadas a la derecha -->
                <div class="acciones-horizontal">

                  <!-- Indicador de favorito -->
                  <button mat-icon-button class="action-btn-small favorito-btn" (click)="toggleFavorito(acceso)"
                    [matTooltip]="acceso.esFavorito ? 'Quitar de favoritos' : 'Agregar a favoritos'">
                    <mat-icon [class.favorito-activo]="acceso.esFavorito" class="icon-small">
                      {{ acceso.esFavorito ? 'star' : 'star_border' }}
                    </mat-icon>
                  </button>

                  <!-- Menú de opciones -->
                  <button mat-icon-button class="action-btn-small" [matMenuTriggerFor]="menuAcceso"
                    matTooltip="Más opciones">
                    <mat-icon class="icon-small">more_vert</mat-icon>
                  </button>

                  <mat-menu #menuAcceso="matMenu">
                    <button mat-menu-item
                      (click)="openDialog({ accion: accionesDialog.Ver, entidad: acceso, modulo: 'AccesosRapidos' })"
                      *appRoles="['AccesosRapidos.Ver']">
                      <mat-icon>visibility</mat-icon>
                      <span>Ver detalles</span>
                    </button>

                    <button mat-menu-item
                      (click)="openDialog({ accion: accionesDialog.Modificar, entidad: acceso, modulo: 'AccesosRapidos' })"
                      *appRoles="['AccesosRapidos.Modificar']">
                      <mat-icon>edit</mat-icon>
                      <span>Editar</span>
                    </button>

                    <button mat-menu-item
                      (click)="openDialog({ accion: accionesDialog.Agregar, entidad:acceso , modulo: 'AccesosRapidos' })">
                      <mat-icon>content_copy</mat-icon>
                      <span>Duplicar</span>
                    </button>

                    <mat-divider></mat-divider>

                    <button mat-menu-item
                      (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: acceso, modulo: 'AccesosRapidos' })"
                      *appRoles="['AccesosRapidos.Eliminar']" class="menu-item-danger">
                      <mat-icon>delete</mat-icon>
                      <span>Eliminar</span>
                    </button>
                  </mat-menu>

                  <!-- Handle para drag & drop -->
                  <mat-icon cdkDragHandle class="drag-handle-small" matTooltip="Arrastrar para reordenar">
                    drag_indicator
                  </mat-icon>
                </div>

              </div>

              <!-- NO hay indicador de favorito flotante -->

            </div>
          </div>
        </div>

        <!-- Mensaje cuando no hay accesos -->
        <ng-template #sinAccesos>
          <div class="mensaje-vacio">
            <mat-icon class="mensaje-icono">bookmark_border</mat-icon>
            <h3>{{ filtroTexto || mostrarSoloFavoritos || grupoSeleccionado ? 'No hay resultados' : 'No tenés accesos
              rápidos' }}</h3>
            <p class="texto-secundario">
              {{ filtroTexto || mostrarSoloFavoritos || grupoSeleccionado
              ? 'Intentá ajustar los filtros para encontrar lo que buscás.'
              : 'Creá tu primer acceso rápido para comenzar.' }}
            </p>
            <button mat-raised-button color="primary"
              (click)="filtroTexto || mostrarSoloFavoritos || grupoSeleccionado ? limpiarFiltros() : openDialog({ accion: accionesDialog.Agregar, modulo: 'AccesosRapidos' })"
              *appRoles="['AccesosRapidos.Crear']">
              <mat-icon>{{ filtroTexto || mostrarSoloFavoritos || grupoSeleccionado ? 'clear_all' : 'add' }}</mat-icon>
              {{ filtroTexto || mostrarSoloFavoritos || grupoSeleccionado ? 'Limpiar filtros' : 'Crear acceso rápido' }}
            </button>
          </div>
        </ng-template>

        <!-- Sugerencias basadas en uso -->
        <div *ngIf="sugerencias.length > 0" class="sugerencias-section">
          <mat-card class="sugerencias-card">
            <mat-card-header>
              <mat-icon mat-card-avatar>lightbulb</mat-icon>
              <mat-card-title>Sugerencias para ti</mat-card-title>
              <mat-card-subtitle>Basadas en tu actividad reciente</mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="sugerencias-lista">
                <div *ngFor="let sugerencia of sugerencias; trackBy: trackBySugerencia" class="sugerencia-item">
                  <div class="sugerencia-info">
                    <mat-icon class="sugerencia-icono">language</mat-icon>
                    <div class="sugerencia-detalles">
                      <div class="sugerencia-url">{{ sugerencia.url }}</div>
                      <div class="sugerencia-motivo">{{ sugerencia.motivo }}</div>
                    </div>
                  </div>
                  <button mat-button color="accent" (click)="agregarDesdeSugerencia(sugerencia)"
                    *appRoles="['AccesosRapidos.Crear']">
                    <mat-icon>add</mat-icon>
                    Agregar
                  </button>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

      </div>
    </mat-card-content>
  </mat-card>
</div>
